export const okHttpCode = 200
export const badRequestHttpError = 400
export const unauthorizedHttpError = 401
export const notFoundHttpError = 404
export const preConditionNotMet = 412
export const internalServerError = 500
export const notImplemented = 501
